import { render, staticRenderFns } from "./Promoters.vue?vue&type=template&id=1d177b64&scoped=true&"
import script from "./Promoters.vue?vue&type=script&lang=js&"
export * from "./Promoters.vue?vue&type=script&lang=js&"
import style0 from "./Promoters.vue?vue&type=style&index=0&id=1d177b64&scoped=true&lang=css&"
import style1 from "./Promoters.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d177b64",
  null
  
)

export default component.exports